import { useContext } from 'react';
import type { StoreApi } from 'zustand/vanilla';
import { EditAreaDraftContext } from './edit-area-draft-context';
import type { EditAreaDraftState } from './edit-area-draft-types';

export const useEditAreaDraftStore = (): StoreApi<EditAreaDraftState> => {
  const store = useContext(EditAreaDraftContext);
  if (!store) throw new Error('EditAreaDraftProvider가 필요합니다.');
  return store;
};
